module.exports = __webpack_public_path__ + "static/img/a1.cc58714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a1.png
// module id = 25
// module chunks = 1